var _path, _path2, _path3, _rect, _g, _path4, _path5, _path6, _rect2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZenLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 974,
    height: 782,
    viewBox: "0 0 974 782",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.161 408.028L280.407 118.082L367.7 174.136L133.161 408.028Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M685.074 205.324L581.946 118.204L788.201 118.204L685.074 205.324Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.177 747.449L613.577 137.562L685.931 205.477L36.177 747.449Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 280.3,
    y: 118.082,
    width: 435.713,
    height: 60.4999,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_422_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M837.367 376.101L690.121 666.047L602.828 609.993L837.367 376.101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.455 578.805L388.582 665.925H182.327L285.455 578.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.25 33.9573L356.952 646.564L284.598 578.65L937.25 33.9573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690.228,
    y: 666.047,
    width: 435.713,
    height: 60.4999,
    transform: "rotate(-180 690.228 666.047)",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.161 408.028L280.407 118.082L367.7 174.136L133.161 408.028Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M685.074 205.324L581.946 118.204L788.201 118.204L685.074 205.324Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.177 747.449L613.577 137.562L685.931 205.477L36.177 747.449Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 280.3,
    y: 118.082,
    width: 435.713,
    height: 60.4999,
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_422_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M837.367 376.101L690.121 666.047L602.828 609.993L837.367 376.101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.455 578.805L388.582 665.925H182.327L285.455 578.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.25 33.9573L356.952 646.564L284.598 578.65L937.25 33.9573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690.228,
    y: 666.047,
    width: 435.713,
    height: 60.4999,
    transform: "rotate(-180 690.228 666.047)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_422_34",
    x: 178.327,
    y: 33.957,
    width: 762.922,
    height: 640.09,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_422_34"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_422_34",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_422_34",
    x: 178.327,
    y: 33.957,
    width: 762.922,
    height: 640.09,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_422_34"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_422_34",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZenLogoWhite);
export default __webpack_public_path__ + "static/media/ZenLogo_white.488f02485601a0e2374f50202b78867c.svg";
export { ForwardRef as ReactComponent };